module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <span class=\"prop-header prop-label\">Set Property Settings</span>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-9 subsection nopadding-r\" style=\"padding-right: 5px!important;\">\r\n        <label class=\"prop-sublabel label-50\">Field</label>\r\n        <div>\r\n            <input type=\"text\" name=\"ValueOfAField\" value=\"")
    ; __append(escapeFn(propertyFieldSelected))
    ; __append("\" readonly=\"readonly\" />\r\n        </div>\r\n    </div>\r\n    <div class=\"col-md-3 nopadding\" style=\"text-align: right;\">\r\n        <button type=\"button\" id=\"selectObject\" class=\"btn btn-default hvr-glow select-button\" name=\"selectObject\">Select</button>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-50\">Property</label>\r\n        <div>\r\n            <select name=\"propertyId\" id=\"propertyId\">\r\n                ")
    ;  for (var i = 0; i < propertyList.length; i++) { 
    ; __append("\r\n                    <option value=\"")
    ; __append(escapeFn(propertyList[i].value))
    ; __append("\">")
    ; __append(escapeFn(propertyList[i].name))
    ; __append("</option>\r\n                ")
    ;  }; 
    ; __append("\r\n            </select>\r\n        </div>\r\n    </div>\r\n</div>\r\n")
  }
  return __output;

}